import { render, staticRenderFns } from "./OrdenServicio.vue?vue&type=template&id=2ea7e28a&scoped=true"
import script from "./OrdenServicio.vue?vue&type=script&lang=js"
export * from "./OrdenServicio.vue?vue&type=script&lang=js"
import style0 from "./OrdenServicio.vue?vue&type=style&index=0&id=2ea7e28a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea7e28a",
  null
  
)

export default component.exports